var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2381 12.3677V14.6534C16.2398 15.0825 16.0606 15.4924 15.7444 15.7824C15.4282 16.0725 15.0044 16.2158 14.5771 16.1772C12.2326 15.9225 9.98054 15.1213 8.00187 13.8382C6.16098 12.6684 4.60022 11.1076 3.43044 9.26674C2.14281 7.27909 1.34148 5.01607 1.09139 2.66103C1.0529 2.23503 1.19522 1.81246 1.4836 1.49655C1.77197 1.18064 2.17985 1.00048 2.60759 1.00007H4.8933C5.65815 0.992547 6.31006 1.55319 6.41711 2.31055C6.51358 3.04203 6.6925 3.76025 6.95044 4.4515C7.15976 5.00836 7.02588 5.63612 6.60758 6.05912L5.63997 7.02674C6.72458 8.9342 8.30393 10.5136 10.2114 11.5982L11.179 10.6306C11.602 10.2123 12.2298 10.0784 12.7866 10.2877C13.4779 10.5456 14.1961 10.7246 14.9276 10.821C15.6937 10.9291 16.2573 11.5942 16.2381 12.3677Z",
    stroke: "#2D3A45",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a5a39dde.svg";
export { ForwardRef as ReactComponent };